import { useEffect, useState } from 'react'
import NoResultsContainer from '../NoResults/NoResults'
import { useByStudent } from '../ByStudentContext/ByStudentContext'
import LoadingLearningGrowth from '../../../../../card/LearningGrowth/Loading'
import { useSelector } from 'react-redux'
import LGColumn from '../../../../../card/LearningGrowth/LGColumn/LGColumn'
import LGRow from '../../../../../card/LearningGrowth/LGRow/LGRow'
import LGDistribution from './LGDistribution'

const LearningGrowth = () => {
  const {
    studentSelected,
    currentCurriculum,
    curriculumId,
    onLoadLearningGrowth,
    loading,
    learningMatrix,
    viewLG,
    dataChart
  } = useByStudent()
  const top = '180px'
  const state = useSelector((state) => state?.filter?.learningMatrix || {})
  const [lcs, setLcs] = useState([])
  const [lgType, setLgType] = useState([])
  const lcElement = currentCurriculum?.lcElements?.children.sort((a, b) => b.position - a.position)?.[0] || {}

  useEffect(() => {
    if (curriculumId && studentSelected) {
      onLoadLearningGrowth(curriculumId, studentSelected, state.filter)
    }
  }, [curriculumId, studentSelected, state.filter])

  useEffect(() => {
    const newLCS =
      learningMatrix?.lcs?.filter((lc) => {
        if (lgType.length === 0) return true
        return lgType.includes(lc.lgType)
      }) || []
    setLcs(newLCS || [])
  }, [learningMatrix?.lcs, lgType])

  const onFilter = (type) => {
    if (lgType.includes(type)) {
      // setLgType(lgType.filter((item) => item !== type));
      setLgType([])
    } else {
      // setLgType([...lgType, type]);
      setLgType([type])
    }
  }

  return (
    <>
      {/* <div className={['absolute inset-x-0 bottom-0 top-0', loading ? 'overflow-hidden' : ''].join(' ')}> */}
      {loading ? (
        <>
          {!viewLG && (
            <div
              className={[
                'sticky inset-x-0 top-0px h-180px bg-background z-22',
                loading ? 'overflow-hidden' : ''
              ].join(' ')}
            >
              <LGDistribution
                loading={loading}
                lcs={lcs || []}
                keyName={lcElement?.name || 'Key skills / knowledge'}
              />
            </div>
          )}
          <LoadingLearningGrowth
            classUlInfo={true}
            direction={viewLG ? 'column' : 'row'}
            currentCurriculum={currentCurriculum || {}}
            top={viewLG ? undefined : top}
          />
        </>
      ) : learningMatrix?.lcs?.length > 0 ? (
        viewLG ? (
          <LGColumn
            lcs={learningMatrix?.lcs || []}
            learningGrowth={dataChart}
            completed={'completedTeacher'}
            currentCurriculum={currentCurriculum || {}}
            classUlInfo={true}
          />
        ) : (
          <>
            <div
              className={[
                'sticky inset-x-0 top-0px h-180px bg-background z-22',
                loading ? 'overflow-hidden' : ''
              ].join(' ')}
            >
              <LGDistribution
                loading={loading}
                lcs={learningMatrix.lcs || []}
                onFilter={onFilter}
                lgType={lgType}
                keyName={lcElement?.name || 'Key skills / knowledge'}
              />
            </div>
            <LGRow
              lcs={lcs || []}
              learningGrowth={dataChart}
              completed={'completedTeacher'}
              currentCurriculum={currentCurriculum || {}}
              classUlInfo={true}
              top={top}
            />
            {lcs.length === 0 && (
              <div
                className='flex items-center justify-start px-4 h-14 bg-background text-muted-foreground bg-muted rounded text-sm font-bold'
                style={{ width: '320px' }}
              >
                {`No learning growth data found.`}
              </div>
            )}
          </>
        )
      ) : (
        <NoResultsContainer />
      )}
      {/* </div> */}
    </>
  )
}

export default LearningGrowth
